import React, { useState } from 'react'
import {  Form } from 'antd'
import NumberFormat from 'react-number-format'
import '../InputField/float.scss'

const NumberField = (props: any) => {
  const [focus, setFocus] = useState(false)
  const { label } = props;

  const handleInputChange = (e) => {
    if (props.handleInputChange){
      props.handleInputChange(e);
    }
  }

  const labelClass = focus || props.value ? 'label label-float' : 'label'
  const input_type=props.type || 'text';
  const input_name=props.name || '';
  return (
    <>
      <Form.Item
        name={input_name}
      >
        <div
          className="float-label input-field"
          onBlur={() => setFocus(false)}
          onFocus={() => setFocus(true)}
        >
          <NumberFormat
            defaultValue  = {props.value}
            value={props.value}
            name={input_name}
            autoFocus={true}
            // format={props.format || '(##) ###-##-##'}
            // mask={'_'}
            // placeholder={props.placeholder || '(00) 000-00-00'}
            format={props.format || false}
            mask={'_'}
            isAllowed={props.isAllowed}
            placeholder={props.placeholder || false}
            // displayType="input"
            onChange={handleInputChange}
            onValueChange={props.onValueChange}
            type={input_type}
            style={props.style}
            className={`${props.className ? props.className : 'ant-input input-field'}`}
            onBlur={props.onBlur}
            allowNegative={false}
            allowedDecimalSeparators={props.allowedDecimalSeparators}
            // fixedDecimalScale
            decimalScale={props.decimalScale}
            decimalSeparator={props.decimalSeparator}
            // isNumericString
            thousandSeparator={props.thousandSeparator || false}
            onClick = {props.onClickNumberFormatFunc}
            
          />
       <label className={props.name == 'phoneNumber' ? 'label label-float' : labelClass}>{label}</label>
        </div>
      </Form.Item>
    </>
  )
}

export default NumberField
